import { render, staticRenderFns } from "./NotificacionesAlertas.vue?vue&type=template&id=090b77e0&scoped=true&"
import script from "./NotificacionesAlertas.vue?vue&type=script&lang=ts&"
export * from "./NotificacionesAlertas.vue?vue&type=script&lang=ts&"
import style0 from "./NotificacionesAlertas.vue?vue&type=style&index=0&id=090b77e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090b77e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('090b77e0', component.options)
    } else {
      api.reload('090b77e0', component.options)
    }
    module.hot.accept("./NotificacionesAlertas.vue?vue&type=template&id=090b77e0&scoped=true&", function () {
      api.rerender('090b77e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/NotificacionesAlertas.vue"
export default component.exports